import React from 'react';
import {TaxContainer} from '../../Containers/OrderContainer';

export const TaxDetails = (props) => {
	return (
		<TaxContainer />
	);
}
export default TaxDetails;